module.exports = __webpack_public_path__ + "7a1274b35d8669f8df65f9c175a04cc2.png";